export interface HeroSlide {
  id: string;
  eyebrow: string;
  title: string;
  description: string;
  image: string;
  link: string;
  meta: string;
}

export const heroSlides: HeroSlide[] = [
  {
    id: "hero-01",
    eyebrow: "本月焦点作品",
    title: "白夜的花火",
    description: "极昼边缘的小镇，一场为遗愿而放的烟火。森田诚执导，绫濑真央、藤井纱良主演。",
    image: "https://readdy.ai/api/search-image?query=Cinematic%20wide%20shot%20of%20white%20fireworks%20blooming%20over%20a%20still%20dark%20lake%20surrounded%20by%20pine%20forest%2C%20warm%20amber%20reflections%20on%20water%2C%20deep%20crimson%20sky%20tones%2C%20atmospheric%20mist%2C%20elegant%20Japanese%20arthouse%20cinema%20aesthetic%2C%20rich%20film%20grain&width=1600&height=900&seq=hero-slide-01&orientation=landscape",
    link: "/detail/work/w17",
    meta: "电影 · 2026 · 评分 8.9",
  },
  {
    id: "hero-02",
    eyebrow: "本周热门剧集",
    title: "东京的四个季节",
    description: "同一条坡道上的四组女性，在四季流转里交错生活。 连续八周进入话题榜的群像作品。",
    image: "https://readdy.ai/api/search-image?query=Cinematic%20wide%20shot%20of%20a%20quiet%20Tokyo%20residential%20slope%20with%20warm%20window%20lights%20at%20dusk%2C%20autumn%20leaves%20and%20soft%20rain%2C%20deep%20crimson%20and%20amber%20tones%2C%20melancholic%20urban%20poetry%2C%20elegant%20Japanese%20cinema%20aesthetic%2C%20subtle%20grain&width=1600&height=900&seq=hero-slide-02&orientation=landscape",
    link: "/detail/work/w03",
    meta: "电视剧 · 2025 · 评分 8.9",
  },
  {
    id: "hero-03",
    eyebrow: "人物特辑",
    title: "绫濑真央 · 安静的叙述者",
    description: "出道十余年，从都市剧到作者电影。本期整理她的代表作品与访谈片段。",
    image: "https://readdy.ai/api/search-image?query=Atmospheric%20cinematic%20wide%20shot%20of%20a%20sunlit%20traditional%20Japanese%20room%20with%20shoji%20screens%20and%20a%20view%20of%20a%20quiet%20garden%2C%20warm%20amber%20light%20and%20soft%20crimson%20shadows%2C%20elegant%20understated%20editorial%20photography%2C%20rich%20film%20texture&width=1600&height=900&seq=hero-slide-03&orientation=landscape",
    link: "/detail/actress/a01",
    meta: "女优档案 · 星野企划",
  },
];

export const siteStats = [
  { label: "女优档案", value: "24", unit: "位" },
  { label: "影视作品", value: "18", unit: "部" },
  { label: "资讯条目", value: "10", unit: "条" },
];

export const categoryShortcuts = [
  {
    title: "按年龄段",
    subtitle: "从新生代到资深演员",
    icon: "ri-user-line",
    accent: "primary",
    options: [
      { label: "18-24 岁", href: "/category?age=18-24" },
      { label: "25-29 岁", href: "/category?age=25-29" },
      { label: "30-34 岁", href: "/category?age=30-34" },
      { label: "35 岁以上", href: "/category?age=35-39" },
    ],
  },
  {
    title: "按出道年份",
    subtitle: "梳理不同世代的演员",
    icon: "ri-calendar-line",
    accent: "accent",
    options: [
      { label: "2011-2014", href: "/category?debut=2011-2014" },
      { label: "2015-2017", href: "/category?debut=2015-2017" },
      { label: "2018-2020", href: "/category?debut=2018-2020" },
      { label: "2021-2023", href: "/category?debut=2021-2023" },
    ],
  },
  {
    title: "按活跃程度",
    subtitle: "当前动向与作品节奏",
    icon: "ri-pulse-line",
    accent: "secondary",
    options: [
      { label: "活跃中", href: "/category?status=active" },
      { label: "休业中", href: "/category?status=paused" },
      { label: "高产演员", href: "/category?sort=works" },
      { label: "新人推荐", href: "/category?debut=2021-2023" },
    ],
  },
];